import { transactionService } from '../services'

export default ( filters) => {
	return new Promise(resolve => {
		transactionService.getResumeAlertsByCategory( filters)
			.then(response => resolve({ success: true, data: response.data }))
	})
}
